import * as React from "react"

const SvgRedHeaderSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={427}
    height={192}
    viewBox="0 0 427 192"
    preserveAspectRatio="none"
    {...props}
  >
    <path d="M427 0H60.581L0 192h427Z" fill="#e32223" />
  </svg>
)

export default SvgRedHeaderSvg
